export default "__VITE_ASSET__DgyjNocs__"